import { Badge } from "@/components/ui/badge";
import {
  CheckCircle,
  XCircle,
  Clock,
  AlertTriangle,
  RefreshCw,
} from "lucide-react";

// Helper function to get status badge
export const getStatusBadge = (status: string) => {
  switch (status) {
    case "won":
      return (
        <Badge className="bg-green-600/30 hover:bg-green-600/40 text-green-400 border border-green-800 text-xs px-2 py-0.5 h-5 gap-1 font-normal">
          <CheckCircle className="h-3 w-3" />
          <span>Won</span>
        </Badge>
      );
    case "lost":
      return (
        <Badge className="bg-red-600/30 hover:bg-red-600/40 text-red-400 border border-red-800 text-xs px-2 py-0.5 h-5 gap-1 font-normal">
          <XCircle className="h-3 w-3" />
          <span>Lost</span>
        </Badge>
      );
    case "void":
      return (
        <Badge className="bg-gray-600/30 hover:bg-gray-600/40 text-gray-400 border border-gray-700 text-xs px-2 py-0.5 h-5 gap-1 font-normal">
          <AlertTriangle className="h-3 w-3" />
          <span>Void</span>
        </Badge>
      );
    case "pending":
    default:
      return (
        <Badge className="bg-yellow-600/30 hover:bg-yellow-600/40 text-yellow-400 border border-yellow-800 text-xs px-2 py-0.5 h-5 gap-1 font-normal">
          <Clock className="h-3 w-3" />
          <span>Pending</span>
        </Badge>
      );
  }
};

// Helper function for validation status badge
export const getValidationBadge = (status: string) => {
  switch (status) {
    case "validated":
      return (
        <Badge className="bg-blue-600/30 hover:bg-blue-600/40 text-blue-400 border border-blue-800 text-xs px-2 py-0.5 h-5 gap-1 font-normal">
          <CheckCircle className="h-3 w-3" />
          <span>Validated</span>
        </Badge>
      );
    case "failed":
      return (
        <Badge className="bg-red-600/30 hover:bg-red-600/40 text-red-400 border border-red-800 text-xs px-2 py-0.5 h-5 gap-1 font-normal">
          <XCircle className="h-3 w-3" />
          <span>Failed</span>
        </Badge>
      );
    case "validating":
      return (
        <Badge className="bg-blue-600/30 hover:bg-blue-600/40 text-blue-400 border border-blue-800 text-xs px-2 py-0.5 h-5 gap-1 font-normal">
          <RefreshCw className="h-3 w-3 animate-spin" />
          <span>Validating</span>
        </Badge>
      );
    case "unvalidated":
    default:
      return (
        <Badge className="bg-zinc-800 hover:bg-zinc-700 text-zinc-400 border border-zinc-700 text-xs px-2 py-0.5 h-5 gap-1 font-normal">
          <span>Unvalidated</span>
        </Badge>
      );
  }
};

// Helper function for job status indicator
export const getJobStatusIndicator = (status: string) => {
  let color = "";
  let icon = null;

  switch (status) {
    case "completed":
      color = "text-green-500";
      icon = <CheckCircle className="h-4 w-4" />;
      break;
    case "failed":
      color = "text-red-500";
      icon = <XCircle className="h-4 w-4" />;
      break;
    case "in_progress":
      color = "text-blue-500";
      icon = <RefreshCw className="h-4 w-4 animate-spin" />;
      break;
    case "queued":
    default:
      color = "text-yellow-500";
      icon = <Clock className="h-4 w-4" />;
      break;
  }

  return (
    <span className={`flex items-center gap-1 ${color}`}>
      {icon}
      <span className="capitalize">{status}</span>
    </span>
  );
};
